module.exports = __webpack_public_path__ + "img/numeros_urgence.37fa6d4d.jpeg";